module.exports = __webpack_public_path__ + "img/[汗].49935c0f.svg";